import React, { useContext, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import { Badge, Collapse } from "@material-ui/core";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import QuestionAnswerOutlinedIcon from "@material-ui/icons/QuestionAnswerOutlined";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import StarOutlineIcon from "@material-ui/icons/StarOutline";
import LocalAtmOutlinedIcon from "@material-ui/icons/LocalAtmOutlined";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import ChatOutlinedIcon from "@material-ui/icons/ChatOutlined";
import DvrIcon from "@material-ui/icons/Dvr";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import QueryBuilderOutlinedIcon from "@material-ui/icons/QueryBuilderOutlined";
import DialpadIcon from "@material-ui/icons/Dialpad";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LinkIcon from "@material-ui/icons/Link";

import { i18n } from "../translate/i18n";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { Can } from "../components/Can";
import { makeStyles } from "@material-ui/core/styles";
import api from "../services/api";
import toastError from "../errors/toastError";
import openSocket from "socket.io-client";
import ConfirmationModal from "../components/ConfirmationModal";
import WabaCalculatorDialog from "../components/WabaCalculatorDialog";

function MenuTooltip({ children, title }) {
  const { drawerOpen } = useContext(DrawerContext);

  if (drawerOpen) return children;

  return (
    <Tooltip title={title} placement="right" arrow>
      {children}
    </Tooltip>
  );
}

const DrawerContext = React.createContext({ drawerOpen: true });

function ListItemLink(props) {
  const { icon, primary, to, className } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  const classes = useClasses();

  return (
    <MenuTooltip title={primary}>
      <li className={classes.icon}>
        <ListItem button component={renderLink} className={className}>
          {icon ? <ListItemIcon className={classes.icon}>{icon}</ListItemIcon> : null}
          <ListItemText className={classes.icon} primary={primary} />
        </ListItem>
      </li>
    </MenuTooltip>
  );
}

/*function ListItemNoLink(props) {
  const { icon, primary, className } = props;

  const classes = useClasses();

  return (
    <MenuTooltip title={primary}>
      <li className={classes.icon}>
        <ListItem button className={className} disabled={true}>
          {icon ? <ListItemIcon disabled={true} className={classes.icon}>{icon}</ListItemIcon> : null}
          <ListItemText className={classes.icon} primary={primary} />
        </ListItem>
      </li>
    </MenuTooltip>
  );
}*/

function ListItemButton(props) {
  const { icon, primary, onClick, className } = props;

  const classes = useClasses();

  return (
    <MenuTooltip title={primary}>
      <li className={classes.icon}>
        <ListItem button onClick={onClick} className={className}>
          {icon ? <ListItemIcon className={classes.icon}>{icon}</ListItemIcon> : null}
          <ListItemText className={classes.icon} primary={primary} />
        </ListItem>
      </li>
    </MenuTooltip>
  );
}

const useClasses = makeStyles((theme) => ({
  icon: {
    color: "#f3f3f3",
    "&.MuiListItemIcon-root": {
      minWidth: 40,
    },
    "&:hover": {
      color: "#b0b0b0",
      "& .MuiListItemIcon-root": {
        color: "#b0b0b0",
      },
    },
  },
  contDocSection: {
    backgroundColor: "#00af71",
  },
  contDocRainbowOutline: {
    outline: "2px solid #ff0000",
    outlineOffset: -2,
    animation: "$rainbowOutline 4s linear infinite",
  },
  "@keyframes rainbowOutline": {
    "0%": {
      outlineColor: "#ff0000",
    },
    "16%": {
      outlineColor: "#ff7a00",
    },
    "33%": {
      outlineColor: "#ffff00",
    },
    "50%": {
      outlineColor: "#00d084",
    },
    "66%": {
      outlineColor: "#00a3ff",
    },
    "83%": {
      outlineColor: "#7a00ff",
    },
    "100%": {
      outlineColor: "#ff0000",
    },
  },
  sectionTitleWithBadge: {
    display: "inline-block",
    position: "relative",
  },
  newBadge: {
    backgroundColor: "#ffeb3b",
    color: "#1f1f1f",
    borderRadius: 10,
    fontSize: 10,
    fontWeight: 700,
    lineHeight: "16px",
    padding: "0 6px",
    position: "absolute",
    right: -58,
    top: -8,
    textTransform: "uppercase",
  },
  submenuItem: {
    paddingLeft: theme.spacing(4),
  },
  collapsedMenu: {
    "& .MuiListItem-root": {
      justifyContent: "center",
      paddingLeft: 0,
      paddingRight: 0,
    },
    "& .MuiListItemIcon-root": {
      justifyContent: "center",
      minWidth: "auto",
      width: "100%",
    },
    "& .MuiListItemText-root": {
      display: "none",
    },
  },
  contDocCollapsedSection: {
    position: "relative",
  },
  contDocCollapsedHeader: {
    minHeight: 48,
    paddingLeft: 0,
    paddingRight: 0,
  },
  contDocCollapsedBadge: {
    backgroundColor: "#ffeb3b",
    color: "#1f1f1f",
    borderRadius: 10,
    fontSize: 8,
    fontWeight: 700,
    lineHeight: "14px",
    padding: "0 5px",
    position: "absolute",
    right: 4,
    top: 3,
    textTransform: "uppercase",
    zIndex: 1,
  },
}));

const MainListItems = (props) => {
  const { drawerClose, drawerOpen, drawerOpenMenu = () => {} } = props;
  const classes = useClasses();
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user } = useContext(AuthContext);
  const [connectionWarning, setConnectionWarning] = useState(false);
  const [botWarning, setBotWarning] = useState(false);
  // const [allowAgendador, setAllowAgendador] = useState("disabled");
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [calculatorOpen, setCalculatorOpen] = useState(false);
  const [CNPJ, setCNPJ] = useState("disabled");
  const [contdocUrl, setContdocUrl] = useState("");
  const [ticketsOpen, setTicketsOpen] = useState(true);
  const [cadastrosOpen, setCadastrosOpen] = useState(true);
  const [adminOpen, setAdminOpen] = useState(true);
  const [contDocOpen, setContDocOpen] = useState(false);
  const [chatBotOpen, setChatBotOpen] = useState(true);
  const hasContDocUrl = !!contdocUrl;
  const submenuItemClass = drawerOpen ? classes.submenuItem : undefined;

  const handleOpenCalculator = () => {
    setCalculatorOpen(true);
  };

  const handleCloseCalculator = () => {
    setCalculatorOpen(false);
  };

  const handleOpenDialog = () => {
    setConfirmationOpen(true);
  };

  const handleCloseDialog = () => {
    setConfirmationOpen(false);
  };

  const handleOpenUrl = () => {
    window.open(`https://financeiro.whatscontabil.com.br/login?cnpj=${CNPJ}`);
  };

  const handleOpenContDocSite = () => {
    window.open("https://contdoc.com/", "_blank");
  };

  const handleContDocHeaderClick = () => {
    if (!drawerOpen) {
      drawerOpenMenu();
      return;
    }

    setContDocOpen((open) => !open);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        setConnectionWarning(offlineWhats.length > 0);
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { data } = await api.get("/settings");

        /*const ag = data.find((setting) => setting.key === "allowAgendador");
        if (ag?.value) {
          setAllowAgendador(ag.value);
        }*/

        const contdocUrlSettings = data.find((setting) => setting.key === "contdocUrl");
        if (contdocUrlSettings?.value) {
          setContdocUrl(contdocUrlSettings.value);
        }

        const cnpj = window.env?.REACT_APP_CNPJ || process.env.REACT_APP_CNPJ;
        setCNPJ(cnpj?.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, "$1.$2.$3/$4-$5"));
      } catch (err) {
        toastError(err);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (user) {
          const queueIds = user.queues?.map((q) => q.id);
          const { data } = await api.get("/ticket2", {
            params: {
              queueIds,
            },
          });

          setBotWarning(data?.length);
        }
      } catch (err) {
        toastError(err);
      }
    })();
  }, [user]);

  useEffect(() => {
    const socket = openSocket(window.env?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL, {
      auth: { token: localStorage.getItem("socketToken") },
    });

    socket.on("ticketBot", async (data) => {
      if (data.action === "update" || data.action === "create" || data.action === "reload") {
        try {
          const queueIds = user.queues.map((q) => q.id);

          const { data: tickets } = await api.get("/ticket2", {
            params: {
              queueIds,
            },
          });

          setBotWarning(tickets?.length);
        } catch (err) {
          toastError(err);
        }
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [user]);

  const renderSectionHeader = (title, icon, open, onClick, badgeLabel) => {
    if (!drawerOpen) return null;

    return (
      <MenuTooltip title={title}>
        <ListItem button onClick={onClick} className={classes.icon}>
          <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
          <ListItemText
            className={classes.icon}
            primary={
              badgeLabel ? (
                <span className={classes.sectionTitleWithBadge}>
                  <span>{title}</span>
                  <span className={classes.newBadge}>{badgeLabel}</span>
                </span>
              ) : (
                title
              )
            }
          />
          {open ? (
            <ExpandLessIcon className={classes.icon} />
          ) : (
            <ExpandMoreIcon className={classes.icon} />
          )}
        </ListItem>
      </MenuTooltip>
    );
  };

  return (
    <DrawerContext.Provider value={{ drawerOpen }}>
    <div className={!drawerOpen ? classes.collapsedMenu : undefined} onClick={drawerClose}>
      <Divider style={{ backgroundColor: "#fcfcfc" }} />
      {renderSectionHeader("Tickets", <WhatsAppIcon />, ticketsOpen, () => setTicketsOpen((open) => !open))}
      <Collapse in={!drawerOpen || ticketsOpen} timeout="auto" unmountOnExit>
        <ListItemLink
          to="/tickets"
          primary="Conversas"
          icon={<WhatsAppIcon />}
          className={submenuItemClass}
        />
        {/*{allowAgendador === "enabled" ? (*/}
          <ListItemLink
            to="/agendamentos"
            primary="Agendamentos"
            icon={<CalendarTodayIcon />}
            className={submenuItemClass}
          />
        {/*) : (
          <ListItemNoLink
            primary="Agendamentos"
            icon={<CalendarTodayIcon />}
            className={submenuItemClass}
          />
        )}*/}
      </Collapse>

      <Divider style={{ backgroundColor: "#fcfcfc" }} />
      {renderSectionHeader("Cadastros", <ContactPhoneOutlinedIcon />, cadastrosOpen, () => setCadastrosOpen((open) => !open))}
      <Collapse in={!drawerOpen || cadastrosOpen} timeout="auto" unmountOnExit>
        <ListItemLink
          to="/contacts"
          primary={i18n.t("mainDrawer.listItems.contacts")}
          icon={<ContactPhoneOutlinedIcon />}
          className={submenuItemClass}
        />
        <ListItemLink
          to="/quickAnswers"
          primary={i18n.t("mainDrawer.listItems.quickAnswers")}
          icon={<ChatOutlinedIcon />}
          className={submenuItemClass}
        />
        <ListItemLink
          to="/tags"
          primary="Tags"
          icon={<LocalOfferOutlinedIcon />}
          className={submenuItemClass}
        />
        <Can
          role={user.profile}
          perform="drawer-admin-items:view"
          yes={() => (
            <>
              <ListItemLink
                to="/templates"
                primary="Templates"
                icon={<AssignmentOutlinedIcon />}
                className={submenuItemClass}
              />
              <ListItemLink
                to="/users"
                primary={i18n.t("mainDrawer.listItems.users")}
                icon={<PeopleAltOutlinedIcon />}
                className={submenuItemClass}
              />
              <ListItemLink
                to="/queues"
                primary={i18n.t("mainDrawer.listItems.queues")}
                icon={<AccountTreeOutlinedIcon />}
                className={submenuItemClass}
              />
            </>
          )}
        />
      </Collapse>

      {/*{ allowEnvioMassa === "enabled" ? (
        <ListItemLink
          to="/envios"
          primary="Envios em Massa"
          icon={<ReplyAllOutlinedIcon />}
        />
      ) : (
        <ListItemNoLink
          primary="Envios em Massa"
          icon={<ReplyAllOutlinedIcon />}
        />
      ) }*/}

      <Can
        role={user.profile}
        perform="drawer-admin-items:view"
        yes={() => (
          <>
            <Divider style={{ backgroundColor: "#fcfcfc" }} />
            {renderSectionHeader(
              i18n.t("mainDrawer.listItems.administration"),
              <DashboardOutlinedIcon />,
              adminOpen,
              () => setAdminOpen((open) => !open)
            )}
            <Collapse in={!drawerOpen || adminOpen} timeout="auto" unmountOnExit>
              <ListItemLink
                to="/"
                primary="Dashboard"
                icon={<DashboardOutlinedIcon />}
                className={submenuItemClass}
              />
              <ListItemLink
                to="/protocolos"
                primary="Protocolos"
                icon={<DvrIcon />}
                className={submenuItemClass}
              />
              <ListItemLink
                to="/connections"
                primary={i18n.t("mainDrawer.listItems.connections")}
                icon={
                  <Badge overlap="rectangular" badgeContent={connectionWarning ? "!" : 0} color="error">
                    <SyncAltIcon />
                  </Badge>
                }
                className={submenuItemClass}
              />
              <ListItemButton
                onClick={handleOpenCalculator}
                primary="Calculadora WABA"
                icon={<DialpadIcon />}
                className={submenuItemClass}
              />
              <ListItemLink
                to="/nps"
                primary="N.P.S."
                icon={<StarOutlineIcon />}
                className={submenuItemClass}
              />
              {user.id === 1 && (
                <ListItemLink
                  to="/logs"
                  primary="Logs"
                  icon={<QueryBuilderOutlinedIcon />}
                  className={submenuItemClass}
                />
              )}
              <ListItemLink
                to="/report"
                primary="Relatórios"
                icon={<AssessmentOutlinedIcon />}
                className={submenuItemClass}
              />
              <ListItemButton
                onClick={handleOpenDialog}
                primary="Faturas"
                icon={<LocalAtmOutlinedIcon />}
                className={submenuItemClass}
              />
              <ListItemLink
                to="/settings"
                primary={i18n.t("mainDrawer.listItems.settings")}
                icon={<SettingsOutlinedIcon />}
                className={submenuItemClass}
              />
            </Collapse>
          </>
        )}
      />

      <div
        className={[
          classes.contDocSection,
          drawerOpen ? classes.contDocRainbowOutline : null,
          !drawerOpen ? classes.contDocCollapsedSection : null,
        ].filter(Boolean).join(" ")}
      >
          <Divider style={{ backgroundColor: "#fcfcfc" }} />
          {drawerOpen ? (
            renderSectionHeader("ContDoc", <DescriptionOutlinedIcon />, contDocOpen, handleContDocHeaderClick, "novidade")
          ) : (
            <MenuTooltip title="ContDoc">
              <ListItem button onClick={handleContDocHeaderClick} className={`${classes.icon} ${classes.contDocCollapsedHeader}`}>
                <span className={classes.contDocCollapsedBadge}>novo</span>
                <ListItemIcon className={classes.icon}>
                  <DescriptionOutlinedIcon />
                </ListItemIcon>
              </ListItem>
            </MenuTooltip>
          )}
          <Collapse in={drawerOpen && contDocOpen} timeout="auto" unmountOnExit>
            {hasContDocUrl ? (
              <>
                <ListItemLink
                  to="/contdoc?page=embed%2Fdashboard"
                  primary="Dashboard"
                  icon={<DashboardOutlinedIcon />}
                  className={submenuItemClass}
                />
                <ListItemLink
                  to="/contdoc?page=embed%2Fclientes"
                  primary="Clientes"
                  icon={<ContactPhoneOutlinedIcon />}
                  className={submenuItemClass}
                />
                <ListItemLink
                  to="/contdoc?page=embed%2Fdocumentos"
                  primary="Documentos"
                  icon={<DescriptionOutlinedIcon />}
                  className={submenuItemClass}
                />
                <ListItemLink
                  to="/contdoc?page=embed%2Fenvios"
                  primary="Envios"
                  icon={<ChatOutlinedIcon />}
                  className={submenuItemClass}
                />
                <ListItemLink
                  to="/contdoc?page=embed%2Fagendamentos"
                  primary="Agendamentos"
                  icon={<CalendarTodayIcon />}
                  className={submenuItemClass}
                />
              </>
            ) : (
              <ListItemButton
                onClick={handleOpenContDocSite}
                primary="Saiba mais"
                icon={<LinkIcon />}
                className={submenuItemClass}
              />
            )}
          </Collapse>
      </div>

      <Divider style={{ backgroundColor: "#fcfcfc" }} />
      {renderSectionHeader("ChatBot", <QuestionAnswerOutlinedIcon />, chatBotOpen, () => setChatBotOpen((open) => !open))}
      <Collapse in={!drawerOpen || chatBotOpen} timeout="auto" unmountOnExit>
        <ListItemLink
          to="/ticketsBot"
          primary="Atendimento auto."
          icon={
            <Badge overlap="rectangular" badgeContent={botWarning ?? 0} color="error">
              <PersonOutlineOutlinedIcon />
            </Badge>
          }
          className={submenuItemClass}
        />
        <ListItemLink
          to="/perguntas"
          primary="Perguntas/Repostas"
          icon={<QuestionAnswerOutlinedIcon />}
          className={submenuItemClass}
        />
      </Collapse>

      <ConfirmationModal
        title={"Abrir faturas"}
        open={confirmationOpen}
        onClose={handleCloseDialog}
        onConfirm={handleOpenUrl}
      >
        <>
          Sua senha de acesso para as faturas é:{" "}
          <b>{((CNPJ?.replace(/\D/g, "").substring(0, 3) * CNPJ?.replace(/\D/g, "").slice(-3)) + new Date().getDate())}</b>
        </>
      </ConfirmationModal>
      <WabaCalculatorDialog
        open={calculatorOpen}
        onClose={handleCloseCalculator}
      />
    </div>
    </DrawerContext.Provider>
  );
};

export default MainListItems;
